import { PropertyImage } from 'components/atoms/PropertyImage/PropertyImage'
import { getPricePerMonth } from '../../common/utils/OfferPage.utils';
import { colors } from 'colors';
import { formatPriceValue } from 'helpers/string.helpers';

interface Props {
  location: string;
  price: number;
  image: string;
  isMulti: boolean;
  unitNumber: string;
}

const PropertyInfo = ({ location, price, image, isMulti, unitNumber }: Props) => {
  return (
    <div className='flex gap-3 items-center p-2' style={{ backgroundColor: colors.secondary }}>
      <div className='w-[96px] h-[72px] min-w-[72px]'>
        <PropertyImage image={image} />
      </div>
      <div>
        <p>
          <span style={{ color: colors.primaryDark }} className='text-[20px]'>{`${formatPriceValue(price)}`}</span>
          <span className='text-[15px]'>/mo</span></p>
        <div className='text-sm'>{location}</div>
        {isMulti && <div>{`(Unit ${unitNumber})`}</div>}
      </div>
    </div>
  )
}

export default PropertyInfo